import React from 'react';
import { HtmlHTMLAttributes } from 'react';
import styled from 'styled-components';
import { color, ColorProps, typography, space, SpaceProps, textAlign, TextAlignProps, variant, TypographyProps } from 'styled-system';
import PropTypes from 'prop-types';
import propTypes from '@styled-system/prop-types';

type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  as?: any;
  children?: React.ReactNode;
} & HtmlHTMLAttributes<HTMLHeadingElement> &
  SpaceProps &
  ColorProps &
  TypographyProps &
  TextAlignProps;

const HeadingBase = ({ level = 1, as: Component = `h${level}`, ...props }: HeadingProps) => <Component {...props} />;

const Heading = styled(HeadingBase).withConfig({
  shouldForwardProp: (prop) => typeof prop === 'string' && !['textAlign'].includes(prop),
})(
  variant({
    prop: 'level',
    variants: {
      1: {
        fontSize: [6, 8],
        lineHeight: '43px',
        mb: 0,
      },
      2: {
        py: '5%',
        mb: 0,
        fontSize: [4, 5],
        lineHeight: '27px',
      },
      3: {
        fontSize: [3, 4],
        lineHeight: '25px',
        mb: 24,
      },
    },
  }),
  space,
  color,
  typography,
  textAlign
);

Heading.propTypes = {
  ...propTypes.space,
  ...propTypes.textAlign,
  ...propTypes.color,
  ...propTypes.typography,
  level: PropTypes.oneOf([1, 2, 3]).isRequired,
  children: PropTypes.node,
};

Heading.defaultProps = {
  mt: 0,
  ml: 0,
  mr: 0,
  color: 'primary.0',
  textAlign: 'left',
};

Heading.displayName = 'Heading';

export default Heading;
